import React, { Fragment } from 'react';
import { Image, Text } from 'react-konva';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import { Layer, Stage, Rect } from 'react-konva';
import { CustomPicker/*, CirclePicker*/ } from 'react-color';
import  { Saturation } from 'react-color/lib/components/common';
import { hexToHSL/*, HSLToHex*/, buildFullNameLineArrBasedOnFontSize, truncateFullNameLineArrBasedOnFontSize, shadeColor } from '../../../library/calc';

import {
  picDim,
  fullNameFontSize,
  fontFamily,
  fullNameFontStyle,
  fullNameLineHeight,
  fullNameFontColor,
  nodeWidth,
  nodeHeight,
  maleDefaultColor,
  femaleDefaultColor,
  unGenderedDefaultColor,
  stageBackgroundDefaultColor,
  maleDefaultHSVColor,
  femaleDefaultHSVColor,
  unGenderedDefaultHSVColor,
  stageBackgroundDefaultHSVColor,
  fullNameLargeFontSize,
  importCustomStylesFromServer,
  isRtl,
  modalPreferencesSubLabelFontSize,
  modalPreferencesFontSize,
  // isDevelopment,
} from '../../../library/constants';
import './index.css';
import Select from 'antd/lib/select';
// import Checkbox from 'antd/lib/checkbox';
import Radio from 'antd/lib/radio';
// import Input from 'antd/lib/input';
// import Button from 'antd/lib/button';


// const { TextArea } = Input;
const { Option } = Select;
const highlightedStrokeWidth = 5;
const multiple = 3;
const strokeColor = 'lightgrey';
const strokeColorHighlight = 'lightgrey';
const strokeWidth = 1;

const margin = 2 * multiple;

const nodeTopPadding = 6;
const nodeLeftPadding = ((picDim * multiple)) + ( margin * 2 );
const rowLineHeight = 6 * multiple;

let presetCustomObj = undefined;

class MySaturationPicker extends React.Component {

  render() {

    return (
      <Saturation
        {...this.props}
      />
    );

  }

}

const SaturationPicker = CustomPicker(MySaturationPicker);


export class Custom extends React.Component {

  customNodeStageCanBeClickedTouchedHovered = true;

  state = {

    maleCustomColor: maleDefaultColor,
    femaleCustomColor: femaleDefaultColor,
    unGenderedCustomColor: unGenderedDefaultColor,
    stageBackgroundCustomColor: stageBackgroundDefaultColor,

    maleStrokeWidth: strokeWidth,
    femaleStrokeWidth: strokeWidth,
    unGenderedStrokeWidth: strokeWidth,
    stageBackgroundStrokeWidth: strokeWidth,

    sliderHSV: maleDefaultHSVColor,
    elementColorChangeTarget: '',
    strokeColor: '#e2e2e2',

    selectedtheme: 'default',

    selectionDropDownReady: false,
    checkBoxLiveNodeReady: true,
    customDataReady: false,

    fontSizeChoice: 'default',
    shadeLevel: -20,
    customFontSize: fullNameFontSize,

  }

  constructor(props){
    super(props);
    this.stepInstructions = [
      'Change text size:',
      'Toggle radio button to change font size.',
      'Choose a color theme:',
      'Create your own custom theme:',
      'Click on an element to select target for color change:',
      'Then click on a shade of color to apply to chosen element.',
      // 'Curators - Share your colors:',
      // 'Or try colors that others have posted:',
    ];

    this.stepInstructions.forEach( (instruction, index)=>{
      if( typeof(window.trl) !== 'undefined' ) this.stepInstructions[index] = window.trl(instruction);
    });

    window.changeShadeLevel = this.changeShadeLevel.bind(this);

  }

  changeShadeLevel(shadeLevel){
    this.setState({
      shadeLevel
    })
  }

  componentDidMount(){

    this.customNodeStage = this.refs.customNodeStage.getStage();
    window.thisStage = this.customNodeStage
    this.customNodeStage.container().style.cursor = 'pointer';

    this.customNodeStage.container().addEventListener('click', (e) => {
      if(!this.customNodeStageCanBeClickedTouchedHovered) return;
      this.changeTargetOfColorChange({color: this.state.stageBackgroundCustomColor, elementColorChangeTarget: 'stageBackground'})
    });

    this.setCustomStylesForPreferences();

  }

  setCustomStylesForPreferences(){

    presetCustomObj = this.props.presetCustomObj;

    if(typeof(importCustomStylesFromServer) === 'undefined'){
      console.log('no importCustomStylesFromServer');
      this.setState({
        selectionDropDownReady: true
      })
      return;
    }

    const hasFontCustom = () => {
      return typeof(this.props.fontSizeChoice) !== 'undefined'
    }

    let setObj = {};

    if( hasFontCustom() ){
      setObj = {...setObj, ...{
        fontSizeChoice: this.props.fontSizeChoice,
        customFontSize: ( this.props.fontSizeChoice === 'default' ? fullNameFontSize : fullNameLargeFontSize)
      }}
    } else {
      setObj = {...setObj, ...{
        customFontSize: fullNameFontSize
      }}
    }

    const selectedtheme = this.props.selectedtheme;
    if( typeof(selectedtheme) !== 'undefined' && typeof(presetCustomObj[selectedtheme]) !== 'undefined' ){
      setObj = { ...setObj, ...{
          selectedtheme: this.props.selectedtheme,
          maleCustomColor:  presetCustomObj[selectedtheme].malePresetColor,
          femaleCustomColor: presetCustomObj[selectedtheme].femalePresetColor,
          unGenderedCustomColor: presetCustomObj[selectedtheme].unGenderedPresetColor,
          stageBackgroundCustomColor: presetCustomObj[selectedtheme].stageBackgroundPresetColor
        }
      }
    }

    this.setState(setObj);

    setTimeout(() => {
      this.setState({
        selectionDropDownReady: true,
        customDataReady: true,
      })

    }, 800);
  }

  createSelectInput(){

    let optionsListArr = [];
    let num = 0;
    const shouldTranslate = ({key, value})=>{
      if( (typeof(value.trl) !== 'undefined' && typeof(window.trl) !== 'undefined') || (key === 'custom'  && typeof(window.trl) !== 'undefined')){
        return true;
      }
      return false;
    }
    for( var key in this.props.presetCustomObj){
      num++;
      const value = this.props.presetCustomObj[key];
      let optionName = key.charAt(0).toUpperCase() + key.slice(1);
      optionName = ( shouldTranslate({key, value}) ? window.trl(optionName): optionName)
      optionsListArr.push(<Option key={num} value={key}>{optionName}</Option>);
    }

    return (
       <Select defaultValue={this.state.selectedtheme} style={{ width: 200, fontSize: `${modalPreferencesSubLabelFontSize}px`}} onChange={this.changeColorTheme.bind(this)}>
          {optionsListArr}
       </Select>
    );

  }

  stopCustomNodeStageClickPropagation(){
    const delayProp = 200;
    this.customNodeStageCanBeClickedTouchedHovered = false;
    clearTimeout(this.customNodeStageCanBeClickedTouchedHoveredTimeOut);
    this.customNodeStageCanBeClickedTouchedHoveredTimeOut =
      setTimeout(() => {
        this.customNodeStageCanBeClickedTouchedHovered = true;
      }, delayProp);
  }


  changeDropListChoiceToCustom(){

    // if( this.state.selectedtheme === 'custom') return;

    const updateDropDownOptionsListWithCustom = () => {

      this.setState({
        selectionDropDownReady: false,
        selectedtheme: 'custom',
      })


      setTimeout(() => {
        this.setState({
          selectionDropDownReady: true
        })
      }, 800);
    }

    updateDropDownOptionsListWithCustom();

  }

  presetConsole(){

    const presetCustomObj = {
      maleCustomColor: this.state.maleCustomColor,
      femaleCustomColor: this.state.femaleCustomColor,
      unGenderedCustomColor: this.state.unGenderedCustomColor,
      stageBackgroundCustomColor: this.state.stageBackgroundCustomColor,
    }

    console.log(`presetCustomObj: `, JSON.stringify(presetCustomObj, null, 2));

    // document.getElementById("customColorTextArea").value = JSON.stringify(presetCustomObj, null, 2);

    // if (typeof(window.logColorPrefs) !== 'undefined'){
    //   window.logColorPrefs(JSON.stringify(presetCustomObj, null, 2));
    // }

  }



  filloutCustomEmptyColorsWithSelectThemeColors(){

    if( typeof(presetCustomObj['custom']) === 'undefined' ) {
      presetCustomObj.custom = {};
    }

    if( typeof(presetCustomObj['custom'].malePresetColor) === 'undefined' || presetCustomObj['custom'].malePresetColor === '' ){
      presetCustomObj['custom'].malePresetColor = presetCustomObj['default'].malePresetColor;
    }
    if( typeof(presetCustomObj['custom'].femalePresetColor) === 'undefined' || presetCustomObj['custom'].femalePresetColor === '' ){
      presetCustomObj['custom'].femalePresetColor = presetCustomObj['default'].femalePresetColor;
    }
    if( typeof(presetCustomObj['custom'].unGenderedPresetColor) === 'undefined'  || presetCustomObj['custom'].unGenderedPresetColor === '' ){
      presetCustomObj['custom'].unGenderedPresetColor = presetCustomObj['default'].unGenderedPresetColor;
    }
    if( typeof(presetCustomObj['custom'].stageBackgroundPresetColor) === 'undefined' || presetCustomObj['custom'].stageBackgroundPresetColor === '' ){
      presetCustomObj['custom'].stageBackgroundPresetColor = presetCustomObj['default'].stageBackgroundPresetColor;
    }

    let setObj = {
      maleCustomColor: presetCustomObj['custom'].malePresetColor,
      femaleCustomColor: presetCustomObj['custom'].femalePresetColor,
      unGenderedCustomColor: presetCustomObj['custom'].unGenderedPresetColor,
      stageBackgroundCustomColor: presetCustomObj['custom'].stageBackgroundPresetColor,
    };

    this.setState(setObj);

  }


  setCustomColorsModal = (color) => {

    // console.log(`color.hsv: `, JSON.stringify(color.hsv, null, 2));
    // console.log(`color hex: `, color.hex);

    let setObj = {};

    if( this.state.elementColorChangeTarget === 'maleNode'){
      setObj = {
        maleCustomColor: color.hex,
      };
      presetCustomObj['custom'].malePresetColor = color.hex
    }

    if( this.state.elementColorChangeTarget === 'femaleNode'){
      setObj = {
        femaleCustomColor: color.hex,
      };
      presetCustomObj['custom'].femalePresetColor = color.hex
    }

    if( this.state.elementColorChangeTarget === 'unGenderNode'){
      setObj = {
        unGenderedCustomColor: color.hex,
      };
      presetCustomObj['custom'].unGenderedPresetColor = color.hex
    }

    if( this.state.elementColorChangeTarget === 'stageBackground'){
      setObj = {
        stageBackgroundCustomColor: color.hex,
      };
      presetCustomObj['custom'].stageBackgroundPresetColor = color.hex
    }

    setObj = {
      ...setObj,
      sliderHSV: color.hsv
    };

    this.setState(setObj);

  }

  changeColorTheme( selection ){

    this.filloutCustomEmptyColorsWithSelectThemeColors()

    let setObj = {
      selectedtheme: selection,
      maleCustomColor: presetCustomObj[selection].malePresetColor,
      femaleCustomColor: presetCustomObj[selection].femalePresetColor,
      unGenderedCustomColor: presetCustomObj[selection].unGenderedPresetColor,
      stageBackgroundCustomColor: presetCustomObj[selection].stageBackgroundPresetColor,

      elementColorChangeTarget: '',
      maleStrokeWidth: strokeWidth,
      femaleStrokeWidth: strokeWidth,
      unGenderedStrokeWidth: strokeWidth,
      stageBackgroundStrokeWidth: strokeWidth,
      stageBackgroundStrokeColor: strokeColor,

      // maleStrokeColor: strokeColor,
      // femaleStrokeColor: strokeColor,
      // unGenderedStrokeColor: strokeColor,
    };

    if (selection === 'custom' ) {
      const sliderHSV = hexToHSL(presetCustomObj[selection].malePresetColor)
      setObj = {...setObj, ...{
        elementColorChangeTarget: 'maleNode',
        maleStrokeWidth: highlightedStrokeWidth,
        sliderHSV,
      }}
    }

    this.setState(setObj);

  }

  changeTargetOfColorChange({color, elementColorChangeTarget}){

    let setObj = {};

    if( this.state.selectedtheme !== 'custom'){
        this.changeDropListChoiceToCustom();

      if ( typeof(presetCustomObj['custom']) !== 'undefined' ){
        setObj = {...setObj, ...{
          sliderHSV: this.getSliderHSVCustomColor(elementColorChangeTarget),
        }};
      } else {
        setObj = {...setObj, ...{
          sliderHSV: this.getSliderHSVDefaultColor(elementColorChangeTarget),
        }};
      }

    } else {
      setObj = {...setObj, ...{
        sliderHSV: hexToHSL(color),
      }};
    }

    if( elementColorChangeTarget === 'maleNode'){
      this.stopCustomNodeStageClickPropagation();
      setObj = {...setObj, ...{
        maleStrokeWidth: highlightedStrokeWidth,
        femaleStrokeWidth: strokeWidth,
        unGenderedStrokeWidth: strokeWidth,
        stageBackgroundStrokeWidth: strokeWidth,
        stageBackgroundStrokeColor: strokeColor,
      }};
    }

    if( elementColorChangeTarget === 'femaleNode'){
      this.stopCustomNodeStageClickPropagation();
      setObj = {...setObj, ...{
        maleStrokeWidth: strokeWidth,
        femaleStrokeWidth: highlightedStrokeWidth,
        unGenderedStrokeWidth: strokeWidth,
        stageBackgroundStrokeWidth: strokeWidth,
        stageBackgroundStrokeColor: strokeColor,
      }};
    }

    if( elementColorChangeTarget === 'unGenderNode'){
      this.stopCustomNodeStageClickPropagation();
      setObj = {...setObj, ...{
        femaleStrokeWidth: strokeWidth,
        maleStrokeWidth: strokeWidth,
        unGenderedStrokeWidth: highlightedStrokeWidth,
        stageBackgroundStrokeWidth: strokeWidth,
        stageBackgroundStrokeColor: strokeColor,
      }};
    }

    if( elementColorChangeTarget === 'stageBackground'){
      setObj = {...setObj, ...{
        unGenderedStrokeWidth: strokeWidth,
        maleStrokeWidth: strokeWidth,
        femaleStrokeWidth: strokeWidth,
        stageBackgroundStrokeWidth: highlightedStrokeWidth,
        stageBackgroundStrokeColor: strokeColorHighlight,
      }};
    }

    setObj = {...setObj, ...{
      selectedtheme: 'custom',
      elementColorChangeTarget,
      checkBoxLiveNodeReady: this.state.livenode ? true : false,
    }};

    this.setState(setObj);

    this.filloutCustomEmptyColorsWithSelectThemeColors();
  }

  shouldUpdate = true;
  shouldComponentUpdate(nextProps, nextState) {
    return this.shouldUpdate;
  }

  getSliderHSVDefaultColor(elementColorChangeTarget){
    const sliderHSV_ColorGenderMapColorGenderMap = {
      maleNode: maleDefaultHSVColor,
      femaleNode: femaleDefaultHSVColor,
      unGenderNode: unGenderedDefaultHSVColor,
      stageBackground: stageBackgroundDefaultHSVColor
    }
    return sliderHSV_ColorGenderMapColorGenderMap[elementColorChangeTarget];
  }

  getSliderHSVCustomColor(elementColorChangeTarget){
    const sliderHSV_ColorGenderMapColorGenderMap = {
      maleNode: hexToHSL(presetCustomObj['custom'].malePresetColor),
      femaleNode: hexToHSL(presetCustomObj['custom'].femalePresetColor),
      unGenderNode: hexToHSL(presetCustomObj['custom'].unGenderedPresetColor),
      stageBackground: hexToHSL(presetCustomObj['custom'].stageBackgroundPresetColor)
    }
    return sliderHSV_ColorGenderMapColorGenderMap[elementColorChangeTarget];
  }

  toggleFontSizeChoice(){
    this.setState({
      fontSizeChoice: ( this.state.fontSizeChoice === 'default' ? 'large': 'default' ),
      customFontSize: ( this.state.fontSizeChoice === 'default' ? fullNameLargeFontSize: fullNameFontSize)
    });
    this.maleCount = 0;
    this.femaleCount = 0;
    this.unknownCount = 0;
  }

  getValueInTextArea(){

    let setObj = JSON.parse(document.getElementById("customColorTextArea").value);
    this.props.setCustomColors(setObj);
    this.setState(setObj);

  }

  onSubmit(){

    let customColorsObj = {
      1:{
        selectedtheme: this.state.selectedtheme,
        fontSizeChoice: this.state.fontSizeChoice,
      }
    }

    if( typeof(presetCustomObj['custom']) !== 'undefined' ){
      customColorsObj[1] = {...customColorsObj[1], custom:{
        maleCustomPresetColor:  presetCustomObj['custom'].malePresetColor,
        femaleCustomPresetColor: presetCustomObj['custom'].femalePresetColor,
        unGenderedCustomPresetColor: presetCustomObj['custom'].unGenderedPresetColor,
        stageBackgroundCustomPresetColor: presetCustomObj['custom'].stageBackgroundPresetColor,
      }}
    }

    this.props.setCustomStylesForTree({newCustomStylesFromPreferences: customColorsObj[1]});
    // console.log(`JSON.stringify(customColorsObj): `, JSON.stringify(JSON.stringify(customColorsObj), null, 2));
    let postObj = {
      callback: () => {},
      skipReloadCanvasTree: true,
      styles: JSON.stringify(customColorsObj),
    };

    this.props.postPreferences(postObj);

    setTimeout(() => {
      this.props.hideModal();
    }, 800);
  }

  maleCount = 0;
  femaleCount = 0;
  unknownCount = 0;
  maleFullNameObj = undefined;
  femaleFullNameObj = undefined;
  unknownFullNameObj = undefined;
  filterFirstGenderNodeObj(){
    if(typeof(this.maleFullNameObj) === 'undefined'){
      this.maleFullNameObj = {
        default: [],
        large: [],
      };
      for( let node in this.props.nodeObjs){
        if( this.maleCount === 0) {
          const isAuthenticNode = () => parseInt(this.props.nodeObjs[node].n, 10) > 0;
          if(this.props.nodeObjs[node].g === 'm' && typeof(this.props.nodeObjs[node].nm) !== 'undefined' && this.props.nodeObjs[node].nm !== 'This Person'  && isAuthenticNode()){
            let nm = this.props.nodeObjs[node].nm;
            const fullNameLineArrDefault = buildFullNameLineArrBasedOnFontSize({fontSizeChoice: 'default', nm});
            const fullNameLineArrLarge = buildFullNameLineArrBasedOnFontSize({fontSizeChoice: 'large', nm});
            this.maleFullNameObj['default'] = truncateFullNameLineArrBasedOnFontSize( { fontSizeChoice: 'default', fullnameArrBasedOnFontSize: fullNameLineArrDefault } );
            this.maleFullNameObj['large'] = truncateFullNameLineArrBasedOnFontSize( { fontSizeChoice: 'large', fullnameArrBasedOnFontSize: fullNameLineArrLarge } );
            this.maleCount++;
          }
        }
      }
    }
    if(typeof(this.femaleFullNameObj) === 'undefined'){
      this.femaleFullNameObj = {
        default: [],
        large: [],
      }
      for( let node in this.props.nodeObjs){
        if( this.femaleCount === 0) {
          const isAuthenticNode = () => parseInt(this.props.nodeObjs[node].n, 10) > 0;
          if(this.props.nodeObjs[node].g === 'f'  && typeof(this.props.nodeObjs[node].nm) !== 'undefined' && this.props.nodeObjs[node].nm !== 'This Person' && isAuthenticNode()){
            const fullNameLineArrDefault = buildFullNameLineArrBasedOnFontSize({fontSizeChoice: 'default', nm: this.props.nodeObjs[node].nm});
            const fullNameLineArrLarge = buildFullNameLineArrBasedOnFontSize({fontSizeChoice: 'large', nm: this.props.nodeObjs[node].nm});
            this.femaleFullNameObj['default'] = truncateFullNameLineArrBasedOnFontSize( { fontSizeChoice: 'default', fullnameArrBasedOnFontSize: fullNameLineArrDefault });
            this.femaleFullNameObj['large'] = truncateFullNameLineArrBasedOnFontSize( { fontSizeChoice: 'large', fullnameArrBasedOnFontSize: fullNameLineArrLarge });
            this.femaleCount++;
          }
        }
      }
    }
    if(typeof(this.unknownFullNameObj) === 'undefined'){
      this.unknownFullNameObj = {
        default: [],
        large: [],
      }
      for( let node in this.props.nodeObjs){
        if( this.unknownCount === 0) {
          const isAuthenticNode = () => parseInt(this.props.nodeObjs[node].n, 10) > 0;
          if(this.props.nodeObjs[node].g === 'u' && typeof(this.props.nodeObjs[node].nm) !== 'undefined'  && isAuthenticNode()){
            const fullNameLineArrDefault = buildFullNameLineArrBasedOnFontSize({fontSizeChoice: 'default', nm: this.props.nodeObjs[node].nm});
            const fullNameLineArrLarge = buildFullNameLineArrBasedOnFontSize({fontSizeChoice: 'large', nm: this.props.nodeObjs[node].nm});
            this.unknownFullNameObj['default'] = truncateFullNameLineArrBasedOnFontSize( { fontSizeChoice: 'default', fullnameArrBasedOnFontSize: fullNameLineArrDefault });
            this.unknownFullNameObj['large'] = truncateFullNameLineArrBasedOnFontSize( { fontSizeChoice: 'large', fullnameArrBasedOnFontSize: fullNameLineArrLarge });
            this.unknownCount++;
          }
        }
      }
    }
  }

  getFullName({ nodeNum, leftEdge, gender }){

    let left = leftEdge + ( nodeLeftPadding  );

    let maleName = 'Male';
    let femaleName = 'Female';
    let unknownGenderName1 = 'Unknown';
    let unknownGenderName2 = 'Gender';
    if( typeof(window.trl) !== 'undefined' ) maleName = window.trl(maleName);
    if( typeof(window.trl) !== 'undefined' ) femaleName = window.trl(femaleName);
    if( typeof(window.trl) !== 'undefined' ) unknownGenderName1 = window.trl(unknownGenderName1);
    if( typeof(window.trl) !== 'undefined' ) unknownGenderName2 = window.trl(unknownGenderName2);

    this.filterFirstGenderNodeObj();

    const maleNameExist = () => {
      return typeof(this.maleFullNameObj[this.state.fontSizeChoice]) !== 'undefined' && this.maleFullNameObj[this.state.fontSizeChoice].length > 0;
    }

    const femaleNameExist = () => {
      return typeof(this.femaleFullNameObj[this.state.fontSizeChoice]) !== 'undefined' && this.femaleFullNameObj[this.state.fontSizeChoice].length > 0;
    }

    const unknownGenderNameExist = () => {
      return typeof(this.unknownFullNameObj[this.state.fontSizeChoice]) !== 'undefined' && this.unknownFullNameObj[this.state.fontSizeChoice].length > 0;
    }

    const male = maleNameExist() ?
      [...this.maleFullNameObj[this.state.fontSizeChoice].slice(0, 3)]:
      truncateFullNameLineArrBasedOnFontSize( {
        fontSizeChoice: this.state.fontSizeChoice,
        fullnameArrBasedOnFontSize: [maleName]
    })

    const female = femaleNameExist()  ?
      [...this.femaleFullNameObj[this.state.fontSizeChoice].slice(0, 3)]:
      truncateFullNameLineArrBasedOnFontSize( {
        fontSizeChoice: this.state.fontSizeChoice,
        fullnameArrBasedOnFontSize: [femaleName]
    })

    const unknown = unknownGenderNameExist() ?
      [...this.unknownFullNameObj[this.state.fontSizeChoice].slice(0, 3)]:
      truncateFullNameLineArrBasedOnFontSize( {
        fontSizeChoice: this.state.fontSizeChoice,
        fullnameArrBasedOnFontSize: [unknownGenderName1, unknownGenderName2]
    })

    const fullnameTextArrayObj = {
      male,
      female,
      unknown,
    }

    let row = 0;

    return fullnameTextArrayObj[gender].map((fullnameText, idx ) => {

      row++;

      return (

        <Text
          onTouchStart={()=>{
            if( gender === 'male') this.changeTargetOfColorChange({color: this.state.maleCustomColor, elementColorChangeTarget: 'maleNode'})
            if( gender === 'female') this.changeTargetOfColorChange({color: this.state.femaleCustomColor, elementColorChangeTarget: 'femaleNode'})
            if( gender === 'unknown') this.changeTargetOfColorChange({color: this.state.unGenderedCustomColor, elementColorChangeTarget: 'unGenderNode'})
          }}
          onClick={()=>{
            if( gender === 'male') this.changeTargetOfColorChange({color: this.state.maleCustomColor, elementColorChangeTarget: 'maleNode'})
            if( gender === 'female') this.changeTargetOfColorChange({color: this.state.femaleCustomColor, elementColorChangeTarget: 'femaleNode'})
            if( gender === 'unknown') this.changeTargetOfColorChange({color: this.state.unGenderedCustomColor, elementColorChangeTarget: 'unGenderNode'})
          }}
          text={`${fullnameText}`}
          x={left}
          y={nodeTopPadding + (rowLineHeight * row)}
          width='auto'
          height={5 * multiple}
          fontSize={this.state.customFontSize * multiple}
          fontFamily={fontFamily}
          fontStyle={fullNameFontStyle}
          lineHeight={fullNameLineHeight}
          fill={fullNameFontColor}
        />
      )
    });

  }

  render() {
    const nodeW = nodeWidth * multiple;
    const nodeH = (nodeHeight * multiple);
    const margin = 2 * multiple;
    const paddingLeft = isRtl ? 35: 25;
    const channelWidth = 30;
    const RectMarginTop = 20;
    return (

      <Fragment>


        {/*


            ********************** ********************** ********************** ********************** **********************
            'Change text size:',
        */}

      <div
        style={{
          position: 'relative',
          width: `100%`,
          height: '20px',
          boxSizing: 'border-box',
          top: '0px',
          fontSize: `${modalPreferencesSubLabelFontSize}px`,
          clear: 'both',
      }}>{ this.stepInstructions[0] }
      </div>


        {/*


            ********************** ********************** ********************** ********************** **********************
            'Toggle radio button to change font size.',

        */}



      <div
        style={{
          position: 'relative',
          width: `100%`,
          height: '20px',
          boxSizing: 'border-box',
          top: '0px',
          fontSize: `${modalPreferencesFontSize}px`,
      }}>{ this.stepInstructions[1] } &nbsp;&nbsp;&nbsp;
        <Radio.Group onChange={this.toggleFontSizeChoice.bind(this)} value={this.state.fontSizeChoice}>
          <Radio value={'default'}>{ typeof(window.trl) !== 'undefined' ? window.trl('Default'): 'Default' }</Radio>
          <Radio value={'large'}>{ typeof(window.trl) !== 'undefined' ? window.trl('Large'): 'Large' }</Radio>
        </Radio.Group>
      </div>


        <div
          style={{
            position: 'relative',
            width: `100%`,
            height: '45px',
            boxSizing: 'border-box',
            top: '10px',
            clear: 'both',
        }}>

        <Row>
          <Col style={{
              paddingLeft: '20px',
              height: '35px',
            }} span={22}>
              <svg width="750" height="20">
              {

                isRtl

                ?
                <line stroke-width="3px" stroke="lightgrey"  x1="120" y1="20" x2="700" y2="20" id="mySVG"/>

                :

                <line stroke-width="3px" stroke="lightgrey"  x1="0" y1="20" x2="700" y2="20" id="mySVG"/>

              }
              </svg>
          </Col>
        </Row>
      </div>

          {/*


              ********************** ********************** ********************** ********************** **********************
              Choose a color theme.

          */}
          <Row>
            <Col span={6} style={{
                paddingLeft: 0,
                height: '55px',
                fontSize: `${modalPreferencesFontSize}px`,
                whiteSpace: 'nowrap',
                width: '214px',
              }}>
              { this.stepInstructions[2] }
            </Col>
            <Col span={13} style={{ paddingLeft: 0 }}>


              {

                  this.state.selectionDropDownReady

                ?

                  this.createSelectInput()


                :

                  null

              }


            </Col>
          </Row>
          <div
            id='customNodeStageWrapper'
            style={{
              position: 'relative',
              left: '0px',
              top: '0px',
              width: `754px`,
              height: '140px',
              backgroundColor: `${this.state.stageBackgroundCustomColor}`,
              boxSizing: 'border-box',
              opacity: 1,
              border: `${this.state.stageBackgroundStrokeWidth}px solid ${this.state.stageBackgroundStrokeColor}`,
          }}>
            <Stage
              className="customNodeStage"
              ref="customNodeStage"
              width={754}
              height={140}
            >
              <Layer>
                <Rect
                  key={`maleNode`}
                  x={paddingLeft}
                  y={RectMarginTop}
                  width={nodeW}
                  height={nodeH}
                  cursor="pointer"

                  fillLinearGradientStartPoint={{  "x": 95,  "y": -90 }}

                  fillLinearGradientEndPoint={ { "x": 95, "y": 90 }}

                  fillLinearGradientColorStops = {[  0,  'white',  1,  this.state.maleCustomColor ]}

                  stroke={`${shadeColor(this.state.maleCustomColor, this.state.shadeLevel)}`}

                  strokeWidth={this.state.maleStrokeWidth}

                  onClick={()=>{
                    this.changeTargetOfColorChange({color: this.state.maleCustomColor, elementColorChangeTarget: 'maleNode'})
                  }}

                  onTouchStart={()=>{
                    this.changeTargetOfColorChange({color: this.state.maleCustomColor, elementColorChangeTarget: 'maleNode'})
                  }}

                />
                  <Image
                    onClick={()=>{
                      this.changeTargetOfColorChange({color: this.state.maleCustomColor, elementColorChangeTarget: 'maleNode'})
                    }}
                    onTouchStart={()=>{
                      this.changeTargetOfColorChange({color: this.state.maleCustomColor, elementColorChangeTarget: 'maleNode'})
                    }}
                    image={this.props.placeholderImage_m}
                    width={picDim * multiple}
                    height={picDim * multiple}
                    x={paddingLeft + margin}
                    y={RectMarginTop + margin}
                    strokeWidth={'1'}
                    stroke={'gray'}
                  />

                  {
                    this.state.customDataReady || typeof(this.props.styles) === 'undefined' ? this.getFullName({nodeNum: 1, leftEdge: paddingLeft, gender: 'male'}): null
                  }
                <Rect
                  key={`female`}
                  x={paddingLeft + nodeW + channelWidth}
                  y={RectMarginTop}
                  width={nodeW}
                  height={nodeH}
                  cursor="pointer"

                  fillLinearGradientStartPoint={{  "x": 95,  "y": -90 }}

                  fillLinearGradientEndPoint={ { "x": 95, "y": 90 }}

                  fillLinearGradientColorStops = {[  0,  'white',  1,  this.state.femaleCustomColor ]}

                  stroke={`${shadeColor(this.state.femaleCustomColor, this.state.shadeLevel)}`}

                  strokeWidth={this.state.femaleStrokeWidth}

                  onClick={()=>{
                    this.changeTargetOfColorChange({color: this.state.femaleCustomColor, elementColorChangeTarget: 'femaleNode'})
                  }}

                  onTouchStart={()=>{
                    this.changeTargetOfColorChange({color: this.state.femaleCustomColor, elementColorChangeTarget: 'femaleNode'})
                  }}

                />
                <Image
                  onClick={()=>{
                    this.changeTargetOfColorChange({color: this.state.femaleCustomColor, elementColorChangeTarget: 'femaleNode'})
                  }}
                  onTouchStart={()=>{
                    this.changeTargetOfColorChange({color: this.state.femaleCustomColor, elementColorChangeTarget: 'femaleNode'})
                  }}

                  image={this.props.placeholderImage_f}
                  width={picDim* 3}
                  height={picDim* 3}
                  x={paddingLeft + nodeW + channelWidth + margin}
                  y={RectMarginTop + margin}
                  strokeWidth={'1'}
                  stroke={'gray'}
                />
                {
                  this.state.customDataReady || typeof(this.props.styles) === 'undefined' ? this.getFullName({nodeNum: 2, leftEdge: paddingLeft + nodeW + channelWidth, gender: 'female'}): null
                }
                <Rect
                  key={`unGenderNode`}
                  x={paddingLeft + (nodeW * 2) + (channelWidth * 2)}
                  y={RectMarginTop}
                  width={nodeW}
                  height={nodeH}
                  cursor="pointer"

                  fillLinearGradientStartPoint={{  "x": 95,  "y": -90 }}

                  fillLinearGradientEndPoint={ { "x": 95, "y": 90 }}

                  fillLinearGradientColorStops = {[  0,  'white',  1,  this.state.unGenderedCustomColor ]}

                  stroke={`${shadeColor(this.state.unGenderedCustomColor, this.state.shadeLevel)}`}

                  strokeWidth={this.state.unGenderedStrokeWidth}

                  onClick={()=>{
                    this.changeTargetOfColorChange({color: this.state.unGenderedCustomColor, elementColorChangeTarget: 'unGenderNode'})
                  }}

                  onTouchStart={()=>{
                    this.changeTargetOfColorChange({color: this.state.unGenderedCustomColor, elementColorChangeTarget: 'unGenderNode'})
                  }}

                />
                <Image
                  onClick={()=>{
                    this.changeTargetOfColorChange({color: this.state.unGenderedCustomColor, elementColorChangeTarget: 'unGenderNode'})
                  }}
                  onTouchStart={()=>{
                    this.changeTargetOfColorChange({color: this.state.unGenderedCustomColor, elementColorChangeTarget: 'unGenderNode'})
                  }}
                  image={this.props.placeholderImage_u}
                  width={picDim * multiple}
                  height={picDim * multiple}
                  x={paddingLeft + (nodeW * 2) + (channelWidth * 2) + margin}
                  y={RectMarginTop + margin}
                  strokeWidth={'1'}
                  stroke={'gray'}
                />

                {
                  this.state.customDataReady || typeof(this.props.styles) === 'undefined' ? this.getFullName({nodeNum: 3, leftEdge: paddingLeft + ((nodeW + channelWidth) * 2), gender: 'unknown'}): null
                }
              </Layer>
            </Stage>
          </div>

          {


                      // <div
                      //   style={{
                      //     position: 'relative',
                      //     width: `100%`,
                      //     top: '0px',
                      //     height: '10px',
                      //     padding: '10px 0px 45px 26px',
                      //     boxSizing: 'border-box',
                      // }}>
                      //   <CirclePicker
                      //     colors={['#2196f3','#e91e63','#8bc34a','#ffeb3b']}
                      //     onChangeComplete={ this.setCustomColors }
                      //     circleSize={32}
                      //     circleSpacing={10}
                      //     width={800}
                      //   />
                      // </div>
          }

          {

           this.state.selectedtheme === 'custom'

           ?

                      <div
                        id="saturationPickerWrapper"
                        style={{
                          position: 'relative',
                          width: `755px`,
                          height: '40px',
                          padding: '10px 0px 14px 2px',
                          boxSizing: 'border-box',
                          marginTop: '10px',
                      }}>{


                        <SaturationPicker
                          hsv={ this.state.sliderHSV }
                          color={ this.state.sliderHSV }
                          onChange={(e)=> this.setCustomColorsModal(e)}
                        />

                      }
                      </div>
           :

           null

          }
          {/*

          <div
            style={{
              position: 'relative',
              width: `100%`,
              height: '20px',
              boxSizing: 'border-box',
              top: '20px',
              clear: 'both',
          }}>

              ********************** ********************** ********************** ********************** **********************
              OR

          <Row>
            <Col style={{
                paddingLeft: '40px',
                height: '20px',
              }} span={10}>
                <svg width="450" height="20">
                  <line stroke-width="3px" stroke="lightgrey"  x1="0" y1="10" x2="300" y2="10" id="mySVG"/>
                </svg>
            </Col>
            <Col span={2} style={{
                paddingLeft: '54px',
                fontSize: `${modalPreferencesFontSize + 1}px`,
                fontWeight: 'bold',
              }}>OR
            </Col>
            <Col style={{
                paddingLeft: '40px',
              }} span={10}>
                <svg width="450" height="20">
                  <line stroke-width="3px" stroke="lightgrey"  x1="0" y1="10" x2="300" y2="10" id="mySVG"/>
                </svg>
            </Col>
          </Row>
        </div>
          */}


          {/*


              ********************** ********************** ********************** ********************** **********************
              Create your own custom theme:

          */}

        <div
          style={{
            position: 'relative',
            width: `100%`,
            height: '20px',
            boxSizing: 'border-box',
            top: '5px',
            fontSize: `${modalPreferencesFontSize}px`,
            clear: 'both',
        }}>{ this.stepInstructions[3] }
        </div>
          {/*

              ********************** ********************** ********************** ********************** **********************
              Click on an element to change its color.

          */}

        <div
          style={{
            position: 'relative',
            width: `100%`,
            height: 'auto',
            boxSizing: 'border-box',
            top: '5px',
            fontSize: `${modalPreferencesFontSize}px`,
            clear: 'both',
        }}><span
          style={{
            whiteSpace: 'nowrap',}}>1) { this.stepInstructions[4] }</span>
          &nbsp;&nbsp;<span  onClick={()=>{
                this.changeTargetOfColorChange({color: this.state.maleCustomColor, elementColorChangeTarget: 'maleNode'})
              }} style={{
                cursor: 'pointer',
              'color': '#257bbd','text-decoration': 'underline', 'font-weight':( this.state.elementColorChangeTarget === 'maleNode'? 'bold': 'initial') }}>{`${  typeof(window.trl) !== 'undefined'  ? window.trl('Male'): 'Male'}`}</span>, <span
              onClick={()=>{
                this.changeTargetOfColorChange({color: this.state.femaleCustomColor, elementColorChangeTarget: 'femaleNode'})
              }}
              style={{
                cursor: 'pointer',
              'color': '#257bbd','text-decoration': 'underline', 'font-weight':( this.state.elementColorChangeTarget === 'femaleNode' ? 'bold': 'initial')}}>{`${  typeof(window.trl) !== 'undefined'  ? window.trl('Female'): 'Female'}`}</span>, <span
              onClick={()=>{
                this.changeTargetOfColorChange({color: this.state.unGenderedCustomColor, elementColorChangeTarget: 'unGenderNode'})
              }}
              style={{
                cursor: 'pointer',
              'color': '#257bbd','text-decoration': 'underline', 'font-weight':( this.state.elementColorChangeTarget === 'unGenderNode' ? 'bold': 'initial')}}>{`${  typeof(window.trl) !== 'undefined'  ? window.trl('Unknown'): 'Unknown'}`}</span>, {`${  typeof(window.trl) !== 'undefined'  ? window.trl('or'): 'or'}`} <span
              onClick={()=>{
                this.changeTargetOfColorChange({color: this.state.stageBackgroundCustomColor, elementColorChangeTarget: 'stageBackground'})
              }}
              style={{
                cursor: 'pointer',
              'color': '#257bbd','text-decoration': 'underline', 'font-weight':( this.state.elementColorChangeTarget === 'stageBackground' ? 'bold': 'initial')}}>{`${  typeof(window.trl) !== 'undefined'  ? window.trl('Background'): 'Background'}`}</span>.

        </div>



          {/*


              ********************** ********************** ********************** ********************** **********************
              'Then click on color or shade of color to apply to chosen element.'

          */}



        <div
          style={{
            position: 'relative',
            width: `100%`,
            height: '10px',
            boxSizing: 'border-box',
            top: '0px',
            fontSize: `${modalPreferencesFontSize}px`,
        }}>2) { this.stepInstructions[5] }

        </div>


        <div
          style={{
            position: 'relative',
            width: `100%`,
            height: '20px',
            boxSizing: 'border-box',
            top: '0px',
            clear: 'both',
        }}>
        </div>


        {/*
        <div
          style={{
            position: 'relative',
            width: `100%`,
            height: '20px',
            boxSizing: 'border-box',
            top: '20px',
            fontSize: `${modalPreferencesFontSize}px`,
            clear: 'both',
        }}>{ this.stepInstructions[6] }&nbsp;&nbsp;
            <a
              style={{
                  'text-decoration': 'underline',
              }}
              onClick={()=>{
                this.presetConsole()
              }}>
            Post to Geni
            </a>
        </div>


          <Row>
            <Col style={{
                paddingLeft: '20px',
                height: '30px',
              }} span={22}>
                <svg width="750" height="20">
                  <line stroke-width="3px" stroke="lightgrey"  x1="0" y1="20" x2="700" y2="20" id="mySVG"/>
                </svg>
            </Col>
          </Row>


        <div
          style={{
            position: 'relative',
            width: `100%`,
            height: '20px',
            boxSizing: 'border-box',
            top: '20px',
            fontSize: `${modalPreferencesFontSize}px`,
            clear: 'both',
        }}>{ this.stepInstructions[6] }&nbsp;&nbsp;
            <a
              style={{
                  'text-decoration': 'underline',
              }}
              onClick={()=>{
                this.presetConsole()
              }}>
            Post to Geni
            </a>
        </div>


          <div
            style={{
              position: 'relative',
              width: `100%`,
              height: '20px',
              boxSizing: 'border-box',
              top: '20px',
              fontSize: `${modalPreferencesFontSize}px`,
              clear: 'both',
          }}>Click&nbsp;
              <a
                style={{
                    'text-decoration': 'underline',
                }}
                onClick={()=>{
                  this.presetConsole()
                }}
              >here</a>&nbsp;to post to Geni.

          </div>

        <div
          style={{
            clear: 'both',
            position: 'relative',
            width: `100%`,
            height: '75px',
            boxSizing: 'border-box',
            top: '20px',
            fontSize: `${modalPreferencesFontSize}px`,
        }}>

          <div
            style={{
              position: 'relative',
              width: `48%`,
              float: 'left',
          }}>{ this.stepInstructions[7]} <TextArea id="customColorTextArea" width="100" rows={1} />
          </div>
          <div
            style={{
              position: 'relative',
              float: 'right',
              'padding-top': '30px',
              'padding-right': '135px',
          }}><Button onClick={(evt)=>{
            this.getValueInTextArea();
          }} type="primary">Apply color sample</Button>
          </div>
        </div>

        */}

      </Fragment>
    );
  }
}



